// tslint:disable:max-line-length

import React from 'react';

export const ActionEdit = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M13,0l-2,2l3,3l2-2L13,0z M10,3l-7.9,7.9l3,3L13,6L10,3z M1,12l-1,4l4-1L1,12z" />
    </svg>
  );
};
